/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementOptionViewModel } from "../types/CourseRegistrationManagementOptionViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const courseRegistrationManagementOptionViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z
      .number()
      .int()
      .describe("ID da matrícula associada à opção de gerenciamento."),
  ),
  courseId: z.optional(z.number().int().describe("ID do curso da matrícula.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à matrícula. Opcional.")
    .nullish(),
  sellerId: z
    .number()
    .int()
    .describe("ID do vendedor responsável pela matrícula. Opcional.")
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  enrollmentStatusText: z
    .string()
    .describe("Descrição textual do status de matrícula.")
    .nullish(),
  available: z.optional(
    z
      .boolean()
      .describe(
        "Indica se esta opção de gerenciamento está disponível para o status atual.",
      ),
  ),
  courseOrClassStudentHasCertificate: z.optional(
    z
      .boolean()
      .describe("Indica se o curso ou a turma possui certificado configurado."),
  ),
}) as unknown as ToZod<CourseRegistrationManagementOptionViewModel>;
